export default {
  getListaMoedas(state) {
    return state.listaMoedas;
  },
  getColunas(state) {
    return state.colunas;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getCampos(state) {
    return state.campos;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
  getMoedas(state) {
    return state.moedas;
  },
};
